@if (shown().length) {
  <div class="layout-row layout-align-start-center full-height threepl-service-chips">
    @for (item of shown(); track $index; let last = $last) {
      <span container="body" class="threepl-service-chips__item" [ngbTooltip]="item">
        <bz-tag class="text-ellipsis" color="var(--bz-gray-105)" textColor="var(--bz-gray-100)">
          <span class="br-body-2">{{ item | translate }}</span>
        </bz-tag>
      </span>
      @if (!last) {
        <span class="margin-right-5 br-body-2">,</span>
      }
    }
    @if (extra().length) {
      <span container="body" class="margin-left-5" [ngbTooltip]="extraTooltip()">
        <bz-tag color="var(--bz-gray-103)" textColor="var(--bz-gray-109)"><span class="br-body-2">+{{ extra().length }}</span></bz-tag>
      </span>
    }
  </div>
}
